module.exports = __webpack_public_path__ + "static/media/4-a_old.93d2efe0.png";